import React from 'react'
import Icon from '../../../../../../components/Icon';
import Divider from '../../../../../../components/Divider';
import Button from '../../../../../../components/inputs/Button';
import ExpansionPanel from '../../../../../../components/ExpansionPanel';
import { Card, CardItem } from '../../../../../../components/Card';
import Modal from '../../../../../../components/Modal';
import Buttons from '../../../../../../modules/Buttons';
import { pathOr, isEmpty } from 'ramda';
import Table from '../../../../../../components/Table';
import FormRemoveSensor from '../../../../components/FormRemoveSensor';
import FormAddSensor from '../../../../components/FormAddSensor';

const Sensors = ({ rowid, sensors, refetchZone }) => {

    return (
        <Card>
            <CardItem
                left={{
                    name: pathOr("", ["sensor", "title"], sensors),
                    value: pathOr("", ["sensor", "info"], sensors)
                }}
                right={<Icon name={pathOr(false, ["sensor", "row_id"], sensors) ? 'icon_tick' : 'icon_untick'} />}
            />
            <Divider />
            <Modal
                renderOpenButton={
                    ({ handleToggleIsOpenModal }) => (
                        <Buttons>
                            <Button
                                onClick={handleToggleIsOpenModal}
                                fullWidth
                                green
                            >
                                {pathOr("", ["sensor", "label"], sensors)}
                            </Button>
                        </Buttons>
                    )
                }
            >
                {
                    pathOr(false, ["sensor", "row_id"], sensors) ?
                        ({ handleToggleIsOpenModal }) => (
                            <FormRemoveSensor
                                sensorid={pathOr(null, ["sensor", "row_id"], sensors)}
                                url='/rpc/remove_sensor'
                                translation={pathOr(false, ["sensor", "modal"], sensors)}
                                cbFetch={() => {
                                    handleToggleIsOpenModal();
                                    refetchZone({ loader: true });
                                }}
                                onClickCancel={handleToggleIsOpenModal}
                            />
                        ) :
                        ({ handleToggleIsOpenModal }) => (
                            <>
                                <CardItem
                                    left={{
                                        name: pathOr("", ["sensor", "title"], sensors),
                                        value: pathOr("", ["sensor", "info"], sensors)
                                    }}
                                    right={<Icon name={pathOr(false, ["sensor", "row_id"], sensors) ? 'icon_tick' : 'icon_untick'} />}
                                />
                                <Divider />
                                <FormAddSensor
                                    zoneid={rowid}
                                    url='/rpc/set_sensor'
                                    urlModal={pathOr(false, ["sensor", "modal", "endpoint"], sensors)}
                                    cbFetch={() => {
                                        handleToggleIsOpenModal();
                                        refetchZone({ loader: true });
                                    }}
                                    onClickCancel={handleToggleIsOpenModal}
                                />
                                <ExpansionPanel
                                    title={pathOr("", ["sensor", "footer"], sensors)}
                                >
                                    {
                                        !isEmpty(pathOr([], ["sensor", "history", "data"], sensors)) ?
                                            <Table
                                                columns={[{
                                                    name: pathOr("", ["sensor", "history", "label", "from"], sensors),
                                                    key: 'from'
                                                }, {
                                                    name: pathOr("", ["sensor", "history", "label", "to"], sensors),
                                                    key: 'to'
                                                }, {
                                                    name: pathOr("", ["sensor", "history", "label", "serial"], sensors),
                                                    key: 'serial'
                                                }]}
                                                data={pathOr([], ["sensor", "history", "data"], sensors)}
                                            />
                                            :
                                            pathOr("", ["sensor", "history", "info"], sensors)
                                    }
                                </ExpansionPanel>
                            </>
                        )
                }
            </Modal>
            <ExpansionPanel
                title={pathOr("", ["sensor", "footer"], sensors)}
            >
                {
                    !isEmpty(pathOr([], ["sensor", "history", "data"], sensors)) ?
                        <Table
                            columns={[{
                                name: pathOr("", ["sensor", "history", "label", "from"], sensors),
                                key: 'from'
                            }, {
                                name: pathOr("", ["sensor", "history", "label", "to"], sensors),
                                key: 'to'
                            }, {
                                name: pathOr("", ["sensor", "history", "label", "serial"], sensors),
                                key: 'serial'
                            }]}
                            data={pathOr([], ["sensor", "history", "data"], sensors)}
                        />
                        :
                        pathOr("", ["sensor", "history", "info"], sensors)
                }
            </ExpansionPanel>
        </Card>
    )
}

export default Sensors
